const formatDates = (date, showYear = true) => {
  const dates = [];

  if (!date) {
    date = new Date();
  }

  dates.push(date.getDate());
  dates.push(date.getMonth() + 1);
  if (showYear) {
    dates.push(date.getFullYear().toString().slice(-2));
  }
  return dates.join("/");
};

function getWeekNumber(date) {
  const startOfYear = new Date(date.getFullYear(), 0, 1);
  const pastDaysOfYear = (date - startOfYear) / 86400000;
  return Math.ceil((pastDaysOfYear + startOfYear.getDay() + 1) / 7);
}

/**
 * Fetches the next weekday from a given date
 * If the weeknumberof the resultDate is the same as the startDate, offset with one week
 * If the startDate is Monday, Tuesday, or Wednesday, it always returns the first day of the next week
 * @param {number} dayOfWeek - The day of the week (0 for Sunday, 1 for Monday, etc.)
 * @param {Date} [startDate] - The optional start date
 * @returns {Date} - The next occurrence of the specified day of the week
 */
function getNextWeekday(dayOfWeek, startDate = new Date()) {
  const isStartDateInTheFuture = startDate > new Date();
  const isStartDateInThePast = startDate < new Date();
  if (isStartDateInThePast) {
    startDate = new Date();
  }

  const targetDate = new Date(startDate.getTime());
  const currentDay = startDate.getDay();

  // Special logic for PRIO products: If current day is Monday (1), Tuesday (2), or Wednesday (3)
  // and we're looking for Wednesday (3), always go to next week's Wednesday
  if ((currentDay >= 1 && currentDay <= 3) && dayOfWeek === 3) {
    // If startDate is in the future, do not add another 7 days
    const daysToAdd = isStartDateInTheFuture
      ? (3 - currentDay)
      : (7 + (3 - currentDay));
    targetDate.setDate(targetDate.getDate() + daysToAdd);
    return targetDate;
  }

  // Original logic for other cases
  const daysOffset = isStartDateInTheFuture ? 0 - currentDay : 7 - currentDay;
  const offset = (daysOffset + dayOfWeek) % 7;
  targetDate.setDate(targetDate.getDate() + offset);

  return targetDate;
}

if (!customElements.get("product-inventory")) {
  class ProductInventory extends HTMLElement {
    constructor() {
      super();
      window.initLazyScript(this, this.initLazySection.bind(this));
    }

    initLazySection() {
      this.inventoryNotice = this.querySelector(".js-inventory-notice");
      this.urgencyMessage = this.querySelector(".js-inventory-urgency");
      this.indicatorBar = this.querySelector(".js-inventory-indicator");
      this.variantInventory = this.getVariantInventory();

      // Bind to on:variant:change event for this product
      this._eventRoot = this.closest(".product-info");
      const variantPicker = this._eventRoot.querySelector("variant-picker");
      if (variantPicker) {
        this._eventRoot.addEventListener(
          "on:variant:change",
          this.handleVariantChange.bind(this));
      }

      // Init
      this.updateInventory(
        parseInt(this.dataset.inventoryQuantity, 10),
        this.dataset.variantAvailable === "true",
        this.dataset.inventoryPolicy
      );
    }

    /**
     * Gets the inventory data for all product variants
     * @returns {?object}
     */
    getVariantInventory() {
      const dataEl = this.querySelector('[type="application/json"]');
      return JSON.parse(dataEl.textContent);
    }

    /**
     * Handles a 'change' event on the variant picker element
     * @param {object} evt - Event object
     */
    handleVariantChange(evt) {
      const v = evt.detail.variant;
      if (v) {
        const inventory = this.variantInventory.find(x => String(x.id) === String(v.id));
        if (!inventory) return;
          this.updateInventory(
          inventory.inventory_quantity,
          inventory.available,
          inventory.inventory_policy
        );
      } else {
        this.updateInventory(0, false);
        this.hidden = true;
      }
    }

    /**
     *
     * Updates the inventory notice
     * @param {number} count - the inventory quantity available
     * @param {boolean} available - whether current variant is available
     * @param {string} inventoryPolicy - whether product continues selling when out of stock
     */
    updateInventory(count, available, inventoryPolicy) {
      let inventoryLevel;

      if (count <= 0) {
        if (inventoryPolicy === "continue") {
          inventoryLevel = "backordered";
        } else if (available && this.dataset.isPreorder === "true") {
          inventoryLevel = "in_stock";
        } else {
          inventoryLevel = "none";
        }
      } else if (count <= parseInt(this.dataset.thresholdVeryLow, 10)) {
        inventoryLevel = "very_low";
      } else if (count <= parseInt(this.dataset.thresholdLow, 10)) {
        inventoryLevel = "low";
      } else {
        inventoryLevel = "normal";
      }

      if (
        this.dataset.showNotice === "always" ||
        (this.dataset.showNotice === "low" && inventoryLevel.includes("low"))
        // &&
        // !(
        //   //inventoryLevel === "backordered"
        //   //&& this.dataset.showNoStockBackordered === "false"
        // )
      ) {
        this.hidden = false;

        // Set the inventory level data attribute
        this.setAttribute("data-inventory-level", inventoryLevel);

        let countText = "";
        let stockMessage = "";
        // Determine whether to show the count or not
        if (
          inventoryLevel === "backordered" ||
          (this.dataset.isPreorder === "true" && !available)
        ) {
          countText = "";
        } else if (
          inventoryLevel !== "in_stock" &&
          (this.dataset.showCount === "always" ||
            (this.dataset.showCount === "low" &&
              inventoryLevel.includes("low"))) &&
          count > 0
        ) {
          countText = theme.strings.onlyXLeft.replace("[quantity]", count);
        } else if (inventoryLevel === "very_low" && count > 0) {
          countText = theme.strings.veryLowStock.replace("[quantity]", count);
        } else if (inventoryLevel === "low" && count > 0) {
          countText = theme.strings.lowStock.replace("[quantity]", count);
        } else if (
          inventoryLevel === "normal" ||
          (inventoryLevel === "in_stock" && count > 0)
        ) {
          countText = theme.strings.inStock.replace("[quantity]", count);
        } else if (inventoryLevel === "none") {
          countText = theme.strings.noStock;
        }

        const stockHidden = count === 0 || this.dataset.isPreorder === 'true' ? "hidden" : "";

        // Check if this item is a preorder item
        if (this.dataset.isPreorder === "true") {
          let preorderString = "";

          
          this.classList.remove("hidden");

          // if ( stockHidden ){
          //   this.classList.add("hidden3");
          // }

          // Replace the string based on the shipping rule
          // TODO: Check this logic
          switch (this.dataset.shippingRule) {
            case "MOET_METEEN_WEG":
              preorderString = theme.strings.preorder;
              break;
            case "MOET_APART_VERSTUURD_WORDEN":
            case "KAN_METEEN_WEG":
            default:
              preorderString = theme.strings.preorder;
              break;
          }

          // format preorderdate to a Javascript date, coming from the DD-MM-YYYY format
          const dateParts = this.dataset.preorderDate.split("/");
          
          let formattedDate = new Date(
            `20${dateParts[2]}`,
            dateParts[1] - 1,
            dateParts[0]
          );

          // If the date is invalid or in the past, set the current date
          // Additionally, the preorder date should not be in the past because of the cronjob rules
          if (isNaN(formattedDate.getTime()) || formattedDate < new Date()) {
            formattedDate = new Date();
          }

          const nextMonday = formatDates(
            getNextWeekday(1, formattedDate),
            false
          );
          const nextWednesday = formatDates(
            getNextWeekday(3, formattedDate),
            false
          );

          //const preorderHidden = this.dataset.isPreorder === "true" ? "hidden" : "";
          const preorderHidden = ''


          stockMessage = 
            "<span class='js-inventory-notice-stock " + stockHidden + "'>" +
              theme.strings.inStock.replace("[quantity]", count) +
              "<br /></span>" + 
              "<span class='js-inventory-notice-preorder " + preorderHidden + "'>" +
            preorderString
              .replace("{{date}}", formatDates(formattedDate, false))
              .replace("{{date1}}", nextMonday)
              .replace("{{date2}}", nextWednesday) + "</span>";

          stockMessage = stockMessage;
        } else if (this.dataset.shippingRule === "MOET_METEEN_WEG") {
          const today = new Date();

          let preorderString = theme.strings.preorder;
          let freshProductDatesString = theme.strings.freshProductDates;

          const dateParts = this.dataset?.date?.split("/");
          let formattedDate = new Date(
            `20${dateParts[2]}`,
            dateParts[1] - 1,
            dateParts[0]
          );

          // If the date is invalid or in the past, set the current date
          // Additionally, the preorder date should not be in the past because of the cronjob rules
          if (isNaN(formattedDate.getTime()) || formattedDate < today) {
            formattedDate = today;
          }

          if (formattedDate <= today) {
            const nextMondayDate = getNextWeekday(1, formattedDate);
            const nextMonday = formatDates(nextMondayDate, false);

            const nextWednesdayDate = getNextWeekday(3, nextMondayDate);
            const nextWednesday = formatDates(nextWednesdayDate, false);

            stockMessage =
              "<span class='js-inventory-notice-stock " + stockHidden + "'>" +
              theme.strings.inStock.replace("[quantity]", count) +
              "<br /></span>" +
              freshProductDatesString
                .replace("{{date1}}", nextMonday)
                .replace("{{date2}}", nextWednesday);
          } else {
            formattedDate = formatDates(formattedDate);
            stockMessage =
              "<span class='js-inventory-notice-stock " + stockHidden + "'>" +
              theme.strings.inStock.replace("[quantity]", count) +
              "<br /></span>" +
              preorderString.replace("{{date}}", formattedDate);
          }

          stockMessage = stockMessage;
        } else if (
          this.dataset.shippingRule === "MOET_APART_VERSTUURD_WORDEN"
        ) {
          stockMessage = theme.strings.inStock.replace("[quantity]", count);
        } else {
          stockMessage = countText;
        }

        this.inventoryNotice.innerHTML = `${stockMessage}`;

        // Update urgency message if needed
        if (this.urgencyMessage) {
          if (inventoryLevel === "very_low") {
            this.urgencyMessage.innerHTML = this.dataset.textVeryLow;
          } else if (inventoryLevel === "low") {
            this.urgencyMessage.innerHTML = this.dataset.textLow;
          } else if (inventoryLevel === "backordered") {
            this.urgencyMessage.innerHTML = this.dataset.textNoStockBackordered;
          } else if (
            inventoryLevel === "normal" ||
            inventoryLevel === "in_stock"
          ) {
            this.urgencyMessage.innerHTML = this.dataset.textNormal;
          } else if (inventoryLevel === "none") {
            this.urgencyMessage.innerHTML = this.dataset.textNoStock;
          }
        }

        // Update the bar indicator
        if (this.indicatorBar) {
          this.indicatorBar.hidden = false;

          let newWidth;
          if (
            (count >= this.dataset.scale || inventoryLevel === "in_stock") &&
            inventoryLevel !== "backordered"
          ) {
            newWidth = 100;
          } else if (
            count <= 0 &&
            this.dataset.isPreorder &&
            this.dataset.inventoryPolicy === "continue"
          ) {
            newWidth = 100;
          } else {
            newWidth = (
              (100 / parseInt(this.dataset.scale, 10)) *
              count
            ).toFixed(1);
          }
          this.indicatorBar.querySelector("span").style.width = `${newWidth}%`;
        }

        // Update button state
        const addToCartBtn = document.querySelector(
          '.js-product-form [name="add"]'
        );
        if (addToCartBtn) {
          if (count > 0 && available) {
            addToCartBtn.removeAttribute("disabled");
          } else if (inventoryLevel == "none") {
            addToCartBtn.setAttribute("disabled", "disabled");
          }
        }

        // Update qty selector
        const qtySelector = document.querySelector(".qty-input__input");
        if (
          qtySelector &&
          ((qtySelector.hasAttribute("max") && inventoryLevel != "none") ||
            this.dataset.isPreorder === "true")
        ) {
          qtySelector.value = 1;
          qtySelector.setAttribute("max", count);
        }
      } else {
        if (this.inventoryPolicy === "continue") {
          console.log("HIDDEN THINGIE TRUE");
        } else {
          this.hidden = true;
        }
      }
    }
  }

  customElements.define("product-inventory", ProductInventory);
}
